import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { toErrorId, toErrorMessage } from '@atlassian/jira-project-settings-apps-common/src/types';
import { famaCatchAndLogFetchError } from '@atlassian/jira-project-settings-apps-common/src/util/catch-and-log-fetch-error';
import { PACKAGE_NAME } from '../../model/constants';

type GetProjectCategoriesData = {
	id: string;
	name: string;
	description: string;
}[];

export const getProjectCategoriesUrl = (baseUrl: string): string =>
	`${baseUrl}/rest/api/3/projectCategory`;

const getProjectCategoriesPromise = (baseUrl: string): Promise<Response> =>
	famaCatchAndLogFetchError(
		fetchJson(getProjectCategoriesUrl(baseUrl)),
		PACKAGE_NAME,
		toErrorId('getProjectCategories'),
		toErrorMessage('Failed to fetch categories for a project'),
	);

const transformResponse = (response: unknown): GetProjectCategoriesData =>
	// @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS7006 - Parameter 'category' implicitly has an 'any' type.
	response.map((category) => ({
		id: category.id,
		name: category.name,
		description: category.description,
	}));
const getProjectCategoriesData = (baseUrl: string): Promise<GetProjectCategoriesData> =>
	getProjectCategoriesPromise(baseUrl).then(transformResponse);

export default getProjectCategoriesData;
